import React, { useState } from "react";
import { Form, Input, Button, Select } from "antd";
const { Option } = Select;

const CardForm = ({ onSubmit, onCancel }) => {
  const [form] = Form.useForm();


  const handleReset = () => {
    form.resetFields();
    onCancel();
  };

  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const handleMonthChange = (value) => {
    setMonth(value);
  };

  const handleYearChange = (value) => {
    setYear(value);
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 10 }, (_, i) => currentYear + i);

  const validateExpiryDate = (_, value) => {
    if (!month || !year) {
      return Promise.reject("Please select both month and year!");
    }

    const cleanValue = month + year.substring(2);
    if (cleanValue.length !== 4) {
      return Promise.reject("Expiry date is invalid! (Valid Format: MMYY)");
    }

    const monthNum = parseInt(month, 10);
    const yearNum = parseInt(year, 10);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    if (monthNum < 1 || monthNum > 12) {
      return Promise.reject("Expiry date is invalid! (Valid Format: MMYY)");
    }

    if (yearNum < currentYear || (yearNum === currentYear && monthNum < currentMonth)) {
      return Promise.reject("Expiry date must be in the future!");
    }

    return Promise.resolve();
  };



  return (
    <div>
    <Form
      layout="vertical"
      form={form}
      onFinish={(values) => {
        // Combine month and year into expiry_date before submitting
        if (month && year) {
          values.expiry_date = `${month}${year.substring(2)}`;
        } else {
        }

        if (onSubmit) {
          onSubmit(values);
          form.resetFields();
        }
      }}
    >
      {/* Document Name Field */}
      <Form.Item
        label="Card Number"
        name="card_number"
        rules={[{ required: true, message: "Please input the Card Number!" },
          { len: 16, message: 'Card Number must be 16 digits!' },
        ]}
      >
        <Input placeholder="0000 0000 0000 0000" maxLength={16}/>
      </Form.Item>

      <Form.Item
          label="Expiry Date"
          // We don't need the expiry_date field in the form, we will handle it through month and year.
          rules={[
            { required: true, message: "Please input a Card Expiry Date!" },
            { validator: validateExpiryDate },
          ]}
      >
        <div style={{ display: 'flex', gap: '8px' }}>
          <Select
              value={month}
              onChange={handleMonthChange}
              placeholder="Month"
              style={{ width: '100px' }}
          >
            {Array.from({ length: 12 }, (_, i) => (
                <Option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                  {String(i + 1).padStart(2, '0')}
                </Option>
            ))}
          </Select>
          <Select
              value={year}
              onChange={handleYearChange}
              placeholder="Year"
              style={{ width: '100px' }}
          >
            {yearOptions.map((yearItem) => (
                <Option key={yearItem} value={String(yearItem)}>
                  {yearItem}
                </Option>
            ))}
          </Select>
        </div>
      </Form.Item>


      <Form.Item
        label="CVV"
        name="cvv"
        rules={[{ required: true, message: "Please input a Card Cvv!" },
          { len: 3, message: 'CVV must be 3 digits!' },
        ]}
      >
       <Input 
        maxLength={3}
        placeholder="Enter cvv" 
        />
      </Form.Item>

      {/* Submit Button */}
      <Button type="primary" htmlType="submit">
        Submit
      </Button>
      <Button htmlType="button" onClick={handleReset}>
        Cancel
      </Button>
    </Form>
  </div>
  );
};

export default CardForm;
